export default __webpack_public_path__ + "img/login_bg.4f2cb0ac.png";